var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _rect, _path8, _circle, _circle2, _circle3, _path9, _path10, _path11, _path12, _rect2, _rect3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 2",
    id: "Layer_2",
    viewBox: "0 0 2000 2000",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#67baeb;}.cls-2{fill:#46a1f8;}.cls-3{fill:#de3226;}.cls-4{fill:#b11a31;}.cls-5{fill:#f44533;}.cls-6{fill:#f8881b;}.cls-7{fill:#f08000;}.cls-8{fill:#f4c23f;}.cls-9{fill:#f4a93f;}.cls-10{fill:#cf6b00;}.cls-11{fill:#2970ef;}.cls-12{fill:#b3e3ff;}"))), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1525.7,1691.3H637c-72.4,0-128-64.1-117.9-135.8L640.4,696.1A119.1,119.1,0,0,1,758.3,593.6h646.1a119.1,119.1,0,0,1,117.9,102.5l121.3,859.4C1653.7,1627.2,1598.1,1691.3,1525.7,1691.3Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M686.1,1555.5,807.4,696.1c8.3-58.8-12.4-102.5,47-102.5H758.3A119.1,119.1,0,0,0,640.4,696.1L519.1,1555.5c-10.1,71.7,45.5,135.8,117.9,135.8H751.5C679.1,1691.3,676,1627.2,686.1,1555.5Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M871.9,1691.3A380.4,380.4,0,0,0,588,1066.8l-68.9,488.7c-10.1,71.7,45.5,135.8,117.9,135.8Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M809.9,842.8a28,28,0,0,0,28-28V593.6h-56V814.8A28,28,0,0,0,809.9,842.8Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1284.8,842.8a28,28,0,0,0,28-28V593.6h-56V814.8A28,28,0,0,0,1284.8,842.8Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1628.3,1447.1H539.7l-5.2-.5-15.4,108.9c-10.1,71.7,45.5,135.8,117.9,135.8h888.7c72.4,0,128-64.1,117.9-135.8Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M605.6,1593v94.1a120.2,120.2,0,0,0,31.4,4.2h888.7c59.4,0,107.6-43.2,117.3-98.3Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    height: 208.28,
    rx: 54.7,
    ry: 54.7,
    transform: "translate(2967.6 50) rotate(90)",
    width: 109.3,
    x: 1404.1,
    y: 1404.7
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M534.5,1446.6l-15.4,108.9c-10.1,71.7,45.5,135.8,117.9,135.8H871.9a380.4,380.4,0,0,0,88.7-244.2H539.7Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 580.2,
    cy: 1447.1,
    r: 303.6
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 580.2,
    cy: 1447.1,
    r: 268.3
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 580.2,
    cy: 1447.1,
    r: 238
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M577.1,1209.1c-130.1,1.7-235,107.6-235,238s104.9,236.4,235,238Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M586.1,1662.7a35.1,35.1,0,0,1-35.1-35v-42.4H486a35.1,35.1,0,0,1,0-70.1H632.9a18.1,18.1,0,0,0,0-36.2H539.1a88.2,88.2,0,0,1,0-176.3H551v-28a35.1,35.1,0,0,1,70.1,0v28h65a35.1,35.1,0,1,1,0,70.1h-147a18.1,18.1,0,0,0,0,36.1h93.8a88.2,88.2,0,0,1,0,176.4H621.1v42.4A35,35,0,0,1,586.1,1662.7Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M623.9,1411.4H530.2a24.6,24.6,0,0,1,0-49.2H677.1a28.6,28.6,0,1,0,0-57.1H605.6v-34.4a28.5,28.5,0,1,0-57,0v34.4H530.2a81.7,81.7,0,1,0,0,163.3h93.7a24.7,24.7,0,0,1,0,49.3H477.1a28.5,28.5,0,1,0,0,57h71.5v48.9a28.5,28.5,0,0,0,57,0v-48.9h18.3a81.7,81.7,0,1,0,0-163.3Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1311.7,842.8a28,28,0,0,1-28-28V515.4a209.5,209.5,0,0,0-418.9,0V814.8a28,28,0,0,1-56,0V515.4a265.5,265.5,0,1,1,530.9,0V814.8A28,28,0,0,1,1311.7,842.8Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    height: 252.81,
    rx: 80.3,
    ry: 80.3,
    transform: "translate(-99.7 203.2) rotate(-7.7)",
    width: 160.5,
    x: 1378.5,
    y: 715.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    height: 120.57,
    rx: 38.3,
    ry: 38.3,
    transform: "translate(-128.5 215) rotate(-7.7)",
    width: 76.6,
    x: 1493.6,
    y: 1001.1
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.ca9ad38caaff85f35f127c913ba8c1c0.svg";
export { ForwardRef as ReactComponent };